module.exports = __webpack_public_path__ + "images/child-progress-page-eb0cc8a76d6898d2c2b1b7e540ecf6d0.png";